module.exports = __webpack_public_path__ + "img/community-norm_zh.c76a3c1d.png";